import { ActionTree } from "vuex";
import { PatientState } from "./types";
import { RootState } from "@/store/types";

export const actions: ActionTree<PatientState, RootState> = {};
